/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as InfraRouteRouteImport } from './routes/infra/route'
import { Route as AuthRouteRouteImport } from './routes/auth/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as InfraDatacentersRouteImport } from './routes/infra/datacenters'
import { Route as AuthLoginRouteImport } from './routes/auth/login'
import { Route as InfraServersRouteRouteImport } from './routes/infra/servers/route'
import { Route as InfraNetworkRouteRouteImport } from './routes/infra/network/route'
import { Route as InfraClustersRouteRouteImport } from './routes/infra/clusters/route'
import { Route as InfraServersIndexRouteImport } from './routes/infra/servers/index'
import { Route as InfraNetworkIndexRouteImport } from './routes/infra/network/index'
import { Route as InfraClustersIndexRouteImport } from './routes/infra/clusters/index'
import { Route as InfraServersPrepareImageRouteImport } from './routes/infra/servers/prepare-image'
import { Route as InfraNetworkAssignSubnetsRouteImport } from './routes/infra/network/assign-subnets'
import { Route as InfraNetworkAddSubnetRouteImport } from './routes/infra/network/add-subnet'
import { Route as InfraClustersCreateRouteImport } from './routes/infra/clusters/create'
import { Route as InfraServersIdRouteRouteImport } from './routes/infra/servers/$id/route'
import { Route as InfraServersIdIndexRouteImport } from './routes/infra/servers/$id/index'
import { Route as InfraServersIdCreatePatchRouteImport } from './routes/infra/servers/$id/create-patch'
import { Route as InfraNetworkEditSubnetSubnetIdRouteImport } from './routes/infra/network/edit-subnet/$subnetId'
import { Route as InfraClustersEditClusterIdRouteImport } from './routes/infra/clusters/edit/$clusterId'
import { Route as InfraServersIdPatchesPatchIdRouteImport } from './routes/infra/servers/$id/patches/$patchId'

const InfraRouteRoute = InfraRouteRouteImport.update({
  id: '/infra',
  path: '/infra',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRouteRoute = AuthRouteRouteImport.update({
  id: '/auth',
  path: '/auth',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const InfraDatacentersRoute = InfraDatacentersRouteImport.update({
  id: '/datacenters',
  path: '/datacenters',
  getParentRoute: () => InfraRouteRoute,
} as any)
const AuthLoginRoute = AuthLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => AuthRouteRoute,
} as any)
const InfraServersRouteRoute = InfraServersRouteRouteImport.update({
  id: '/servers',
  path: '/servers',
  getParentRoute: () => InfraRouteRoute,
} as any)
const InfraNetworkRouteRoute = InfraNetworkRouteRouteImport.update({
  id: '/network',
  path: '/network',
  getParentRoute: () => InfraRouteRoute,
} as any)
const InfraClustersRouteRoute = InfraClustersRouteRouteImport.update({
  id: '/clusters',
  path: '/clusters',
  getParentRoute: () => InfraRouteRoute,
} as any)
const InfraServersIndexRoute = InfraServersIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => InfraServersRouteRoute,
} as any)
const InfraNetworkIndexRoute = InfraNetworkIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => InfraNetworkRouteRoute,
} as any)
const InfraClustersIndexRoute = InfraClustersIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => InfraClustersRouteRoute,
} as any)
const InfraServersPrepareImageRoute =
  InfraServersPrepareImageRouteImport.update({
    id: '/prepare-image',
    path: '/prepare-image',
    getParentRoute: () => InfraServersRouteRoute,
  } as any)
const InfraNetworkAssignSubnetsRoute =
  InfraNetworkAssignSubnetsRouteImport.update({
    id: '/assign-subnets',
    path: '/assign-subnets',
    getParentRoute: () => InfraNetworkRouteRoute,
  } as any)
const InfraNetworkAddSubnetRoute = InfraNetworkAddSubnetRouteImport.update({
  id: '/add-subnet',
  path: '/add-subnet',
  getParentRoute: () => InfraNetworkRouteRoute,
} as any)
const InfraClustersCreateRoute = InfraClustersCreateRouteImport.update({
  id: '/create',
  path: '/create',
  getParentRoute: () => InfraClustersRouteRoute,
} as any)
const InfraServersIdRouteRoute = InfraServersIdRouteRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => InfraServersRouteRoute,
} as any)
const InfraServersIdIndexRoute = InfraServersIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => InfraServersIdRouteRoute,
} as any)
const InfraServersIdCreatePatchRoute =
  InfraServersIdCreatePatchRouteImport.update({
    id: '/create-patch',
    path: '/create-patch',
    getParentRoute: () => InfraServersIdRouteRoute,
  } as any)
const InfraNetworkEditSubnetSubnetIdRoute =
  InfraNetworkEditSubnetSubnetIdRouteImport.update({
    id: '/edit-subnet/$subnetId',
    path: '/edit-subnet/$subnetId',
    getParentRoute: () => InfraNetworkRouteRoute,
  } as any)
const InfraClustersEditClusterIdRoute =
  InfraClustersEditClusterIdRouteImport.update({
    id: '/edit/$clusterId',
    path: '/edit/$clusterId',
    getParentRoute: () => InfraClustersRouteRoute,
  } as any)
const InfraServersIdPatchesPatchIdRoute =
  InfraServersIdPatchesPatchIdRouteImport.update({
    id: '/patches/$patchId',
    path: '/patches/$patchId',
    getParentRoute: () => InfraServersIdRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/auth': typeof AuthRouteRouteWithChildren
  '/infra': typeof InfraRouteRouteWithChildren
  '/infra/clusters': typeof InfraClustersRouteRouteWithChildren
  '/infra/network': typeof InfraNetworkRouteRouteWithChildren
  '/infra/servers': typeof InfraServersRouteRouteWithChildren
  '/auth/login': typeof AuthLoginRoute
  '/infra/datacenters': typeof InfraDatacentersRoute
  '/infra/servers/$id': typeof InfraServersIdRouteRouteWithChildren
  '/infra/clusters/create': typeof InfraClustersCreateRoute
  '/infra/network/add-subnet': typeof InfraNetworkAddSubnetRoute
  '/infra/network/assign-subnets': typeof InfraNetworkAssignSubnetsRoute
  '/infra/servers/prepare-image': typeof InfraServersPrepareImageRoute
  '/infra/clusters/': typeof InfraClustersIndexRoute
  '/infra/network/': typeof InfraNetworkIndexRoute
  '/infra/servers/': typeof InfraServersIndexRoute
  '/infra/clusters/edit/$clusterId': typeof InfraClustersEditClusterIdRoute
  '/infra/network/edit-subnet/$subnetId': typeof InfraNetworkEditSubnetSubnetIdRoute
  '/infra/servers/$id/create-patch': typeof InfraServersIdCreatePatchRoute
  '/infra/servers/$id/': typeof InfraServersIdIndexRoute
  '/infra/servers/$id/patches/$patchId': typeof InfraServersIdPatchesPatchIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/auth': typeof AuthRouteRouteWithChildren
  '/infra': typeof InfraRouteRouteWithChildren
  '/auth/login': typeof AuthLoginRoute
  '/infra/datacenters': typeof InfraDatacentersRoute
  '/infra/clusters/create': typeof InfraClustersCreateRoute
  '/infra/network/add-subnet': typeof InfraNetworkAddSubnetRoute
  '/infra/network/assign-subnets': typeof InfraNetworkAssignSubnetsRoute
  '/infra/servers/prepare-image': typeof InfraServersPrepareImageRoute
  '/infra/clusters': typeof InfraClustersIndexRoute
  '/infra/network': typeof InfraNetworkIndexRoute
  '/infra/servers': typeof InfraServersIndexRoute
  '/infra/clusters/edit/$clusterId': typeof InfraClustersEditClusterIdRoute
  '/infra/network/edit-subnet/$subnetId': typeof InfraNetworkEditSubnetSubnetIdRoute
  '/infra/servers/$id/create-patch': typeof InfraServersIdCreatePatchRoute
  '/infra/servers/$id': typeof InfraServersIdIndexRoute
  '/infra/servers/$id/patches/$patchId': typeof InfraServersIdPatchesPatchIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/auth': typeof AuthRouteRouteWithChildren
  '/infra': typeof InfraRouteRouteWithChildren
  '/infra/clusters': typeof InfraClustersRouteRouteWithChildren
  '/infra/network': typeof InfraNetworkRouteRouteWithChildren
  '/infra/servers': typeof InfraServersRouteRouteWithChildren
  '/auth/login': typeof AuthLoginRoute
  '/infra/datacenters': typeof InfraDatacentersRoute
  '/infra/servers/$id': typeof InfraServersIdRouteRouteWithChildren
  '/infra/clusters/create': typeof InfraClustersCreateRoute
  '/infra/network/add-subnet': typeof InfraNetworkAddSubnetRoute
  '/infra/network/assign-subnets': typeof InfraNetworkAssignSubnetsRoute
  '/infra/servers/prepare-image': typeof InfraServersPrepareImageRoute
  '/infra/clusters/': typeof InfraClustersIndexRoute
  '/infra/network/': typeof InfraNetworkIndexRoute
  '/infra/servers/': typeof InfraServersIndexRoute
  '/infra/clusters/edit/$clusterId': typeof InfraClustersEditClusterIdRoute
  '/infra/network/edit-subnet/$subnetId': typeof InfraNetworkEditSubnetSubnetIdRoute
  '/infra/servers/$id/create-patch': typeof InfraServersIdCreatePatchRoute
  '/infra/servers/$id/': typeof InfraServersIdIndexRoute
  '/infra/servers/$id/patches/$patchId': typeof InfraServersIdPatchesPatchIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/auth'
    | '/infra'
    | '/infra/clusters'
    | '/infra/network'
    | '/infra/servers'
    | '/auth/login'
    | '/infra/datacenters'
    | '/infra/servers/$id'
    | '/infra/clusters/create'
    | '/infra/network/add-subnet'
    | '/infra/network/assign-subnets'
    | '/infra/servers/prepare-image'
    | '/infra/clusters/'
    | '/infra/network/'
    | '/infra/servers/'
    | '/infra/clusters/edit/$clusterId'
    | '/infra/network/edit-subnet/$subnetId'
    | '/infra/servers/$id/create-patch'
    | '/infra/servers/$id/'
    | '/infra/servers/$id/patches/$patchId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/auth'
    | '/infra'
    | '/auth/login'
    | '/infra/datacenters'
    | '/infra/clusters/create'
    | '/infra/network/add-subnet'
    | '/infra/network/assign-subnets'
    | '/infra/servers/prepare-image'
    | '/infra/clusters'
    | '/infra/network'
    | '/infra/servers'
    | '/infra/clusters/edit/$clusterId'
    | '/infra/network/edit-subnet/$subnetId'
    | '/infra/servers/$id/create-patch'
    | '/infra/servers/$id'
    | '/infra/servers/$id/patches/$patchId'
  id:
    | '__root__'
    | '/'
    | '/auth'
    | '/infra'
    | '/infra/clusters'
    | '/infra/network'
    | '/infra/servers'
    | '/auth/login'
    | '/infra/datacenters'
    | '/infra/servers/$id'
    | '/infra/clusters/create'
    | '/infra/network/add-subnet'
    | '/infra/network/assign-subnets'
    | '/infra/servers/prepare-image'
    | '/infra/clusters/'
    | '/infra/network/'
    | '/infra/servers/'
    | '/infra/clusters/edit/$clusterId'
    | '/infra/network/edit-subnet/$subnetId'
    | '/infra/servers/$id/create-patch'
    | '/infra/servers/$id/'
    | '/infra/servers/$id/patches/$patchId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthRouteRoute: typeof AuthRouteRouteWithChildren
  InfraRouteRoute: typeof InfraRouteRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/infra': {
      id: '/infra'
      path: '/infra'
      fullPath: '/infra'
      preLoaderRoute: typeof InfraRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth': {
      id: '/auth'
      path: '/auth'
      fullPath: '/auth'
      preLoaderRoute: typeof AuthRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/infra/datacenters': {
      id: '/infra/datacenters'
      path: '/datacenters'
      fullPath: '/infra/datacenters'
      preLoaderRoute: typeof InfraDatacentersRouteImport
      parentRoute: typeof InfraRouteRoute
    }
    '/auth/login': {
      id: '/auth/login'
      path: '/login'
      fullPath: '/auth/login'
      preLoaderRoute: typeof AuthLoginRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/infra/servers': {
      id: '/infra/servers'
      path: '/servers'
      fullPath: '/infra/servers'
      preLoaderRoute: typeof InfraServersRouteRouteImport
      parentRoute: typeof InfraRouteRoute
    }
    '/infra/network': {
      id: '/infra/network'
      path: '/network'
      fullPath: '/infra/network'
      preLoaderRoute: typeof InfraNetworkRouteRouteImport
      parentRoute: typeof InfraRouteRoute
    }
    '/infra/clusters': {
      id: '/infra/clusters'
      path: '/clusters'
      fullPath: '/infra/clusters'
      preLoaderRoute: typeof InfraClustersRouteRouteImport
      parentRoute: typeof InfraRouteRoute
    }
    '/infra/servers/': {
      id: '/infra/servers/'
      path: '/'
      fullPath: '/infra/servers/'
      preLoaderRoute: typeof InfraServersIndexRouteImport
      parentRoute: typeof InfraServersRouteRoute
    }
    '/infra/network/': {
      id: '/infra/network/'
      path: '/'
      fullPath: '/infra/network/'
      preLoaderRoute: typeof InfraNetworkIndexRouteImport
      parentRoute: typeof InfraNetworkRouteRoute
    }
    '/infra/clusters/': {
      id: '/infra/clusters/'
      path: '/'
      fullPath: '/infra/clusters/'
      preLoaderRoute: typeof InfraClustersIndexRouteImport
      parentRoute: typeof InfraClustersRouteRoute
    }
    '/infra/servers/prepare-image': {
      id: '/infra/servers/prepare-image'
      path: '/prepare-image'
      fullPath: '/infra/servers/prepare-image'
      preLoaderRoute: typeof InfraServersPrepareImageRouteImport
      parentRoute: typeof InfraServersRouteRoute
    }
    '/infra/network/assign-subnets': {
      id: '/infra/network/assign-subnets'
      path: '/assign-subnets'
      fullPath: '/infra/network/assign-subnets'
      preLoaderRoute: typeof InfraNetworkAssignSubnetsRouteImport
      parentRoute: typeof InfraNetworkRouteRoute
    }
    '/infra/network/add-subnet': {
      id: '/infra/network/add-subnet'
      path: '/add-subnet'
      fullPath: '/infra/network/add-subnet'
      preLoaderRoute: typeof InfraNetworkAddSubnetRouteImport
      parentRoute: typeof InfraNetworkRouteRoute
    }
    '/infra/clusters/create': {
      id: '/infra/clusters/create'
      path: '/create'
      fullPath: '/infra/clusters/create'
      preLoaderRoute: typeof InfraClustersCreateRouteImport
      parentRoute: typeof InfraClustersRouteRoute
    }
    '/infra/servers/$id': {
      id: '/infra/servers/$id'
      path: '/$id'
      fullPath: '/infra/servers/$id'
      preLoaderRoute: typeof InfraServersIdRouteRouteImport
      parentRoute: typeof InfraServersRouteRoute
    }
    '/infra/servers/$id/': {
      id: '/infra/servers/$id/'
      path: '/'
      fullPath: '/infra/servers/$id/'
      preLoaderRoute: typeof InfraServersIdIndexRouteImport
      parentRoute: typeof InfraServersIdRouteRoute
    }
    '/infra/servers/$id/create-patch': {
      id: '/infra/servers/$id/create-patch'
      path: '/create-patch'
      fullPath: '/infra/servers/$id/create-patch'
      preLoaderRoute: typeof InfraServersIdCreatePatchRouteImport
      parentRoute: typeof InfraServersIdRouteRoute
    }
    '/infra/network/edit-subnet/$subnetId': {
      id: '/infra/network/edit-subnet/$subnetId'
      path: '/edit-subnet/$subnetId'
      fullPath: '/infra/network/edit-subnet/$subnetId'
      preLoaderRoute: typeof InfraNetworkEditSubnetSubnetIdRouteImport
      parentRoute: typeof InfraNetworkRouteRoute
    }
    '/infra/clusters/edit/$clusterId': {
      id: '/infra/clusters/edit/$clusterId'
      path: '/edit/$clusterId'
      fullPath: '/infra/clusters/edit/$clusterId'
      preLoaderRoute: typeof InfraClustersEditClusterIdRouteImport
      parentRoute: typeof InfraClustersRouteRoute
    }
    '/infra/servers/$id/patches/$patchId': {
      id: '/infra/servers/$id/patches/$patchId'
      path: '/patches/$patchId'
      fullPath: '/infra/servers/$id/patches/$patchId'
      preLoaderRoute: typeof InfraServersIdPatchesPatchIdRouteImport
      parentRoute: typeof InfraServersIdRouteRoute
    }
  }
}

interface AuthRouteRouteChildren {
  AuthLoginRoute: typeof AuthLoginRoute
}

const AuthRouteRouteChildren: AuthRouteRouteChildren = {
  AuthLoginRoute: AuthLoginRoute,
}

const AuthRouteRouteWithChildren = AuthRouteRoute._addFileChildren(
  AuthRouteRouteChildren,
)

interface InfraClustersRouteRouteChildren {
  InfraClustersCreateRoute: typeof InfraClustersCreateRoute
  InfraClustersIndexRoute: typeof InfraClustersIndexRoute
  InfraClustersEditClusterIdRoute: typeof InfraClustersEditClusterIdRoute
}

const InfraClustersRouteRouteChildren: InfraClustersRouteRouteChildren = {
  InfraClustersCreateRoute: InfraClustersCreateRoute,
  InfraClustersIndexRoute: InfraClustersIndexRoute,
  InfraClustersEditClusterIdRoute: InfraClustersEditClusterIdRoute,
}

const InfraClustersRouteRouteWithChildren =
  InfraClustersRouteRoute._addFileChildren(InfraClustersRouteRouteChildren)

interface InfraNetworkRouteRouteChildren {
  InfraNetworkAddSubnetRoute: typeof InfraNetworkAddSubnetRoute
  InfraNetworkAssignSubnetsRoute: typeof InfraNetworkAssignSubnetsRoute
  InfraNetworkIndexRoute: typeof InfraNetworkIndexRoute
  InfraNetworkEditSubnetSubnetIdRoute: typeof InfraNetworkEditSubnetSubnetIdRoute
}

const InfraNetworkRouteRouteChildren: InfraNetworkRouteRouteChildren = {
  InfraNetworkAddSubnetRoute: InfraNetworkAddSubnetRoute,
  InfraNetworkAssignSubnetsRoute: InfraNetworkAssignSubnetsRoute,
  InfraNetworkIndexRoute: InfraNetworkIndexRoute,
  InfraNetworkEditSubnetSubnetIdRoute: InfraNetworkEditSubnetSubnetIdRoute,
}

const InfraNetworkRouteRouteWithChildren =
  InfraNetworkRouteRoute._addFileChildren(InfraNetworkRouteRouteChildren)

interface InfraServersIdRouteRouteChildren {
  InfraServersIdCreatePatchRoute: typeof InfraServersIdCreatePatchRoute
  InfraServersIdIndexRoute: typeof InfraServersIdIndexRoute
  InfraServersIdPatchesPatchIdRoute: typeof InfraServersIdPatchesPatchIdRoute
}

const InfraServersIdRouteRouteChildren: InfraServersIdRouteRouteChildren = {
  InfraServersIdCreatePatchRoute: InfraServersIdCreatePatchRoute,
  InfraServersIdIndexRoute: InfraServersIdIndexRoute,
  InfraServersIdPatchesPatchIdRoute: InfraServersIdPatchesPatchIdRoute,
}

const InfraServersIdRouteRouteWithChildren =
  InfraServersIdRouteRoute._addFileChildren(InfraServersIdRouteRouteChildren)

interface InfraServersRouteRouteChildren {
  InfraServersIdRouteRoute: typeof InfraServersIdRouteRouteWithChildren
  InfraServersPrepareImageRoute: typeof InfraServersPrepareImageRoute
  InfraServersIndexRoute: typeof InfraServersIndexRoute
}

const InfraServersRouteRouteChildren: InfraServersRouteRouteChildren = {
  InfraServersIdRouteRoute: InfraServersIdRouteRouteWithChildren,
  InfraServersPrepareImageRoute: InfraServersPrepareImageRoute,
  InfraServersIndexRoute: InfraServersIndexRoute,
}

const InfraServersRouteRouteWithChildren =
  InfraServersRouteRoute._addFileChildren(InfraServersRouteRouteChildren)

interface InfraRouteRouteChildren {
  InfraClustersRouteRoute: typeof InfraClustersRouteRouteWithChildren
  InfraNetworkRouteRoute: typeof InfraNetworkRouteRouteWithChildren
  InfraServersRouteRoute: typeof InfraServersRouteRouteWithChildren
  InfraDatacentersRoute: typeof InfraDatacentersRoute
}

const InfraRouteRouteChildren: InfraRouteRouteChildren = {
  InfraClustersRouteRoute: InfraClustersRouteRouteWithChildren,
  InfraNetworkRouteRoute: InfraNetworkRouteRouteWithChildren,
  InfraServersRouteRoute: InfraServersRouteRouteWithChildren,
  InfraDatacentersRoute: InfraDatacentersRoute,
}

const InfraRouteRouteWithChildren = InfraRouteRoute._addFileChildren(
  InfraRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthRouteRoute: AuthRouteRouteWithChildren,
  InfraRouteRoute: InfraRouteRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
